import React from "react";

const TileBodyMessage = ({ children, className }) => {
    return <div className={`Tile-body-message ${className ? className : ""}`}>{children}</div>;
};
export default TileBodyMessage;
